<template>
  <div class="row">
    <div class="col-12 py-2 text-center">
      <font-awesome-icon icon="spinner" class="fa-2xl mb-2" spin />
      <h5>LOADING....</h5>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
export default {
  name: "BaseLoader"
}
</script>

<style scoped>

</style>